import requestor from "requestor";

import BaseRoute from "utils/base_route";
import ScoresContainer from "./containers/scores";

import llmRunBatchesRecentFetchAction from "modules/flowmaster/actions/llm_run_batches_recent_fetch";

export default class extends BaseRoute {
  constructor(store) {
    super("llm-scores", store);
  }

  getComponents(location, cb) {
    cb(null, ScoresContainer);
  }

  onEnter(state) {
    this.fetchData(state);
  }

  fetchData(state) {
    this.fetchRecentBatches(state);
  }

  clearActiveData(state) {
    this.clearContractTypes(state);
    this.clearSearch();
  }

  fetchRecentBatches(state) {
    const {organisationId} = state.params;
    this.store.dispatch(
      llmRunBatchesRecentFetchAction(requestor)(organisationId),
    );
  }
}
